module.exports = "/info/img/videoMask1.jpg";